const TagButton = ({ name, val , handleSetTag, tagActive }) => {
	return (
		<button className={`btn ${tagActive ? 'active' : null}`} onClick={() => handleSetTag(val)}>
			{name.toUpperCase()}
		</button>
	);
};

export default TagButton;